import React from 'react'

import Link from '@/components/link/link'

import * as style from './pagination.module.scss'

type Props = {
  basePath: string
  numPages: number
  currentPage: number
}

const Pagination: React.FC<Props> = ({ basePath, numPages, currentPage }) => {
  const isLast = currentPage === Array(numPages).length
  const isFirst = currentPage === 1
  const showFirstLast = numPages > 3
  const itemsToLoop =
    currentPage === 1
      ? [currentPage, currentPage + 1, currentPage + 2]
      : currentPage !== Array(numPages).length
        ? [currentPage - 1, currentPage, currentPage + 1]
        : [currentPage - 2, currentPage - 1, currentPage]

  return (
    <div className={style.pagination}>
      {numPages > 1 && (
        <div className="container">
          <div className="row">
            <div className="col">
              <ul>
                <li
                  className={style.firstitem}
                  style={
                    !isFirst && showFirstLast
                      ? { display: 'block' }
                      : { display: 'none' }
                  }
                >
                  <Link key="first" to={basePath}>
                    First
                  </Link>
                </li>

                {[...Array(numPages).keys()].map((item, index) => {
                  const pageNum = item + 1
                  const isCurrent = currentPage === pageNum
                  const pageNumFormatted = pageNum < 9 ? '0' + pageNum : pageNum
                  if (itemsToLoop.includes(index + 1)) {
                    return (
                      <li
                        key={pageNum}
                        className={`${style.item} ${
                          isCurrent ? style.current : ''
                        } ${
                          Array(numPages).length === index + 1
                            ? style.lastchild
                            : ''
                        }`}
                      >
                        {!isCurrent ? (
                          <Link
                            to={
                              pageNum === 1
                                ? basePath
                                : basePath + pageNum + '/'
                            }
                          >
                            {pageNumFormatted}
                          </Link>
                        ) : (
                          <div> {pageNumFormatted}</div>
                        )}
                      </li>
                    )
                  } else {
                    return null
                  }
                })}

                <li
                  key="last"
                  className={style.lastitem}
                  style={
                    !isLast && showFirstLast
                      ? { display: 'block' }
                      : { display: 'none' }
                  }
                >
                  <Link to={basePath + numPages + '/'}>Last</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Pagination
